import { ProcessedImage, ImageProcessingResult } from './types';

export async function processImportedImages(files: File[]): Promise<ImageProcessingResult> {
  const processedImages: ProcessedImage[] = [];
  const errors: string[] = [];

  for (const file of files) {
    try {
      const data = await readImageFile(file);
      processedImages.push({
        filename: file.name,
        data
      });
    } catch (error) {
      const message = `Failed to process image ${file.name}: ${error instanceof Error ? error.message : '不明なエラー'}`;
      errors.push(message);
      console.error(message);
    }
  }

  return {
    success: errors.length === 0,
    images: processedImages,
    errors
  };
}

function readImageFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error(`Failed to read file: ${file.name}`));
    reader.readAsDataURL(file);
  });
}